import { FC, MouseEvent } from 'react';
import { Box, ButtonBase } from '@mui/material';
import { ClosedTransactionsCellProps } from './ClosedTransactionsCell.props';

const ClosedTransactionsCell: FC<ClosedTransactionsCellProps> = ({ row, onClosedTransactionsClick }) => {
  const groups = row.record.secondary_breakdown?.closed_transactions ?? [];
  const latest = groups[0];
  if (!latest) {
    return null;
  }

  const moreCount = groups.length - 1;
  const sinceLastValuation = Boolean(latest.since_last_valuation);

  const openDialog = (event: MouseEvent) => {
    event.stopPropagation();
    onClosedTransactionsClick(row);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      height="100%"
      // pr=0 so the right edge lines up with the number columns, which sit on the
      // td's own 4px padding.
      pl={0.5}
      pr={0}
      sx={{ overflow: 'hidden' }}>
      <ButtonBase
        id={`closed-transactions-cell-${row.companyId}`}
        data-testid={`closed-transactions-cell-${row.companyId}`}
        onClick={openDialog}
        aria-label={
          sinceLastValuation ? `${latest.display}, since last valuation` : latest.display
        }
        data-since-last-valuation={sinceLastValuation ? 'true' : undefined}
        sx={{
          alignItems: 'center',
          color: sinceLastValuation ? 'error.main' : 'inherit',
          cursor: 'pointer',
          display: 'flex',
          flex: 1,
          fontFamily: 'inherit',
          fontSize: 'inherit',
          fontWeight: sinceLastValuation ? 700 : 400,
          gap: 0.75,
          justifyContent: 'flex-end',
          minWidth: 0,
          padding: 0,
          textAlign: 'right',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}>
        <Box
          component="span"
          sx={{
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
          {latest.display}
        </Box>
        {moreCount >= 1 && (
          <Box
            component="span"
            data-testid={`closed-transactions-more-${row.companyId}`}
            sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
            {`+${moreCount} more`}
          </Box>
        )}
      </ButtonBase>
    </Box>
  );
};

export default ClosedTransactionsCell;
